export function getVisibleCollectionOptions(options) {
  return options.filter(option => !option.hidden && option.getAttribute("aria-disabled") !== "true");
}
export function wrapCollectionIndex(index, direction, length) {
  if (length === 0) {
    return -1;
  }
  if (direction === 1) {
    return index >= length - 1 ? 0 : index + 1;
  }
  return index <= 0 ? length - 1 : index - 1;
}
export function clearCollectionActive(options, activeHost) {
  activeHost?.removeAttribute("aria-activedescendant");
  for (const option of options) {
    option.removeAttribute("data-active");
  }
}
export function setCollectionActive(options, visibleOptions, index, activeHost, idPrefix) {
  clearCollectionActive(options, activeHost);
  const active = visibleOptions[index];
  if (!active || !activeHost) {
    return null;
  }
  if (!active.id) {
    active.id = `${idPrefix}-${index}`;
  }
  active.setAttribute("data-active", "true");
  activeHost.setAttribute("aria-activedescendant", active.id);
  active.scrollIntoView({
    block: "nearest"
  });
  return active;
}